import { Box, Button, Card, CardContent, CircularProgress, Grid, Tooltip, Typography } from '@mui/material';
import { Fragment, useState } from 'react';
import { useDispatch } from 'react-redux';
import Constant from '../../../../../../Utils/Constant';
import Skeleton from 'react-loading-skeleton';
import AGGREMENTICON from '../../../../../../Assets/Images/aggrementIcon.png';
import Swal from 'sweetalert2';
import { USER_INTERPRETER_LANGUAGE_COMMISION_FIRST_ACTION, USER_INTERPRETO_ACCOUNT_APPROVE_FIRST } from '../../../../../../Redux/Slices/UserSlice/User.action';
import { toast } from 'react-toastify';
import CustomRejectInterpreter from '../../../../../../Components/CustomRejectInterpreter/CustomRejectInterpreter';
import NoDataImg from '../../../../../../Components/NoDataFound/NoDataFound';
import AxiosInstance from '../../../../../../Config/AxiosInstance';
import APILIST from '../../../../../../Config/ApiList';
const InterpreterReviewProfile = (props) => {
    const dispatch = useDispatch();
    const { interpreterDetails, isLoading, handleSubmitAcceptReject, setIsLoading } = props;
    const [status, setStatus] = useState(null);
    const [userId, setUserId] = useState(null);
    const [profileRejectModel, setProfileRejectModel] = useState(false);
    const handleInterPreterAccountStatusChange = async (userId, status) => {
        Swal.fire({
            title: 'Are you sure?',
            text: status === 1 ? 'Do you want to approve this request?' : 'Do you want to reject this request?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            reverseButtons: true,
        }).then(async (result) => {
            if (result.isConfirmed) {
                if (status === 1 && interpreterDetails?.user_languages?.length > 0) {
                    const formData = new FormData();
                    formData.append("user_id", userId);
                    const data = interpreterDetails?.user_languages?.map(language => ({
                        id: language?.id,
                        commission: interpreterDetails?.is_premium === 1 ? 20 : 30
                    }));
                    formData.append("commission", JSON.stringify(data));
                    const res = await dispatch(USER_INTERPRETER_LANGUAGE_COMMISION_FIRST_ACTION(formData)).unwrap();
                    if (res && res?.s === 1) {
                        const userLanguageList = interpreterDetails?.user_languages
                        const approvalRes = await dispatch(USER_INTERPRETO_ACCOUNT_APPROVE_FIRST({ userId, status, userLanguageList })).unwrap();
                        for (const language of userLanguageList) {
                            const certificates = language?.certificates || [];
                            for (const cert of certificates) {
                                const formDataCert = new FormData();
                                formDataCert.append("certificate_id", cert.id);
                                formDataCert.append("status", status);
                                await AxiosInstance.post(`${APILIST.ADD_UPDATE_CERTIFICATE_REQUEST}/${cert.id}`, formDataCert);
                            }
                        }
                        if (approvalRes && approvalRes?.s === 1) {
                            toast.success("Request Approved Successfully!");
                            handleSubmitAcceptReject();
                            setIsLoading(false)
                        } else {
                            toast.error(approvalRes?.m);
                            setIsLoading(false)
                        }
                    }
                } else {
                    toast.error("Cannot approve interpreter without any languages");
                }
            }
        });
    };
    const handleUserInterpreterAccountRejectModel = async (userId, status) => {
        setProfileRejectModel(true);
        setStatus(status);
        setUserId(userId);
    }
    return (
        <Fragment>
            <Grid item xs={12} sm={7} md={7} lg={9}>
                <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} md={12}>
                        <Box sx={{
                            width: '300px'
                        }}>
                            <Typography sx={{
                                color: "rgba(0, 151, 178, 1)",
                                fontSize: { xs: '18px', md: "22px" },
                                fontWeight: "500",
                                fontFamily: 'Outfit',
                                textAlign: 'left',
                                marginBottom: '10px'
                            }}>Govt ID</Typography>
                            {isLoading ? <Skeleton height={200} width={300} /> : <img src={interpreterDetails?.govt_certificate ? `${Constant.BASE_URL}${interpreterDetails?.govt_certificate}` : 'https://res.cloudinary.com/do0g7smfg/image/upload/v1711695885/cld-sample.jpg'} alt='goveId' style={{
                                width: '100%',
                                borderRadius: '15px',
                                height: '155px',
                                objectFit: 'cover',
                                objectPosition: 'top'
                            }} />}
                        </Box>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container spacing={1}>
                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                <Typography
                                    variant="h6"
                                    sx={{
                                        color: "rgba(0, 151, 178, 1)",
                                        fontSize: { xs: '18px', md: "22px" },
                                        fontWeight: "500",
                                        fontFamily: "Outfit",
                                    }}
                                >
                                    Language & Certification Details
                                </Typography>
                                <Box sx={{
                                    width: '100%',
                                    borderRadius: '5px',
                                    padding: '20px 10px'
                                }}>
                                    <Grid container spacing={2}>
                                        {interpreterDetails && interpreterDetails?.user_languages?.length > 0 ? interpreterDetails?.user_languages?.map((elem, index) => {
                                            return (
                                                <Grid item xs={12} sm={12} md={4} key={index}>
                                                    <Card>
                                                        <CardContent sx={{
                                                            background: "rgba(250, 250, 250, 1)",
                                                            borderRadius: '15px',
                                                            borderColor: "1px solid rgba(8, 85, 127, 0.2)"
                                                        }}>
                                                            <Box sx={{
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: 'space-between'
                                                            }}>
                                                                <Typography sx={{
                                                                    fontSize: '14px',
                                                                    fontWeight: '600',
                                                                    fontFamily: "Outfit",
                                                                    color: '#000'
                                                                }}>{elem?.language}</Typography>
                                                                {elem?.sign_lang === 1 && <Typography sx={{
                                                                    background: 'rgba(0, 151, 178, 0.2)',
                                                                    padding: '5px 10px',
                                                                    borderRadius: '20px',
                                                                    fontSize: '14px',
                                                                    fontWeight: '500',
                                                                    fontFamily: "Outfit",
                                                                    color: 'rgba(2, 56, 85, 1)'
                                                                }}>Sign Language</Typography>}
                                                            </Box>
                                                            <Typography sx={{
                                                                padding: '5px 0px',
                                                                fontSize: '14px',
                                                                fontWeight: '600',
                                                                fontFamily: "Outfit",
                                                            }}>Hourly Rate : {`$${elem?.hourly_rate}`}</Typography>

                                                            <Box sx={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'flex-start',
                                                                gridGap: '10px',
                                                                flexWrap: 'wrap'
                                                            }}>
                                                                {elem?.certificates && elem?.certificates?.map((elem, index) => {
                                                                    return <img
                                                                        key={index}
                                                                        src={`${Constant.BASE_URL}${elem?.certificate}`} style={{
                                                                            width: '50px',
                                                                            height: '50px',
                                                                            objectFit: 'cover',
                                                                            borderRadius: '5px'
                                                                        }}
                                                                        alt='language_document'
                                                                    />
                                                                }
                                                                )}
                                                            </Box>
                                                        </CardContent>
                                                    </Card>
                                                </Grid>
                                            )
                                        }) : <Grid item xs={12}>
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                }}>
                                                <NoDataImg />
                                            </Box>
                                        </Grid>}
                                    </Grid>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={12} md={6} lg={10}>
                                <Typography
                                    variant="h6"
                                    sx={{
                                        color: "rgba(0, 151, 178, 1)",
                                        fontSize: { xs: '18px', md: "22px" },
                                        fontWeight: "500",
                                        fontFamily: "Outfit",
                                    }}
                                >
                                    Agreement Details
                                </Typography>
                                <Grid container spacing={1}>
                                    {isLoading ? (
                                        Array(3).fill().map((_, index) => (
                                            <Grid item xs={12} key={index}>
                                                <Box sx={{
                                                    background: "rgba(250, 250, 250, 1)",
                                                    padding: '15px',
                                                    borderRadius: '15px',
                                                    width: '100%',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'space-between',
                                                }}>
                                                    <Box sx={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'flex-start',
                                                        gridGap: '10px',
                                                    }}>
                                                        <Skeleton circle width={48} height={48} />
                                                        <Skeleton width={100} height={30} />
                                                    </Box>
                                                    <Skeleton width={100} height={50} />
                                                </Box>
                                            </Grid>
                                        ))
                                    ) : (
                                        interpreterDetails && interpreterDetails?.user_agreement.length > 0 ? (
                                            interpreterDetails?.user_agreement?.map((elem, index) => {
                                                return (
                                                    <Grid item xs={12} key={index}>
                                                        <Box sx={{
                                                            background: "rgba(250, 250, 250, 1)",
                                                            padding: '15px',
                                                            borderRadius: '15px',
                                                            width: '100%',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'space-between',
                                                        }}>
                                                            <Box sx={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'flex-start',
                                                                gridGap: '10px',
                                                            }}>
                                                                <Box sx={{
                                                                    width: '48px',
                                                                    height: '48px',
                                                                }}>
                                                                    <img src={AGGREMENTICON} alt="Agreement" style={{ width: '100%' }} />
                                                                </Box>
                                                                <Typography sx={{
                                                                    fontSize: '14px',
                                                                    fontWeight: '600',
                                                                    fontFamily: "Outfit",
                                                                    color: 'rgba(8, 85, 127, 1)',
                                                                }}>
                                                                    {elem?.agreement}
                                                                </Typography>
                                                            </Box>
                                                            {elem?.user_agreement_signature ? (
                                                                <img
                                                                    src={`${Constant.BASE_URL}${elem?.user_agreement_signature}`}
                                                                    alt='signature'
                                                                    style={{
                                                                        width: '180px',
                                                                        height: '80px',
                                                                        background: 'transparent',
                                                                    }}
                                                                />
                                                            ) : "N/A"}
                                                        </Box>
                                                    </Grid>
                                                )
                                            }

                                            )
                                        ) : (
                                            <Grid item xs={12}>
                                                <Typography sx={{
                                                    textAlign: 'center',
                                                    padding: '10px',
                                                }}>
                                                    Not available agreement
                                                </Typography>
                                            </Grid>
                                        )
                                    )}
                                </Grid>
                            </Grid>
                            <Grid item xs={12}>
                                <Box sx={{ gridGap: '10px', display: 'flex', justifyContent: 'flex-start', alignItems: 'center', marginTop: '20px' }}>
                                    <Tooltip title="Approve Request">
                                        <Button
                                            sx={{
                                                background: "rgba(48, 156, 59, 1)",

                                                "&:hover": { background: "#388e3c" },
                                                color: "white",
                                                fontFamily: 'Outfit',
                                                width: '170px',
                                                height: "50px",
                                                borderRadius: "11px",
                                            }}
                                            onClick={() => handleInterPreterAccountStatusChange(interpreterDetails?.id, 1)}
                                        >
                                            {isLoading ? <CircularProgress
                                                size={32}
                                                sx={{
                                                    color: "#fff",
                                                }}
                                            /> : "Accept"}
                                        </Button>
                                    </Tooltip>
                                    <Tooltip title="Reject Request">
                                        <Button
                                            sx={{
                                                background: "#c62828",
                                                "&:hover": { background: "#c62828" },
                                                color: "white",
                                                fontFamily: 'Outfit',
                                                width: '170px',
                                                height: "50px",
                                                borderRadius: "11px",
                                            }}
                                            onClick={() => {
                                                handleUserInterpreterAccountRejectModel(interpreterDetails?.id, -1);

                                            }}
                                        >
                                            {isLoading ? <CircularProgress
                                                size={32}
                                                sx={{
                                                    color: "#fff",
                                                }}
                                            /> : "Reject"}
                                        </Button>
                                    </Tooltip>
                                </Box>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <CustomRejectInterpreter
                open={profileRejectModel}
                onClose={() => setProfileRejectModel(false)}
                userId={userId}
                handleOnClose={() => setProfileRejectModel(false)}
                status={status}
                handleSubmitAcceptReject={handleSubmitAcceptReject}
            />
        </Fragment>
    );
};

export default InterpreterReviewProfile;